/* "A new version is ready."
 *
 * The service worker is registerType: 'autoUpdate', which installs a new build
 * in the background and then waits — the old one keeps control of every open tab
 * until all of them close. So a deploy lands, a refresh does nothing, and the
 * app carries on serving the previous bundle while looking perfectly healthy.
 *
 * That cost three rounds of "I can't see the change" in one day, each time with
 * the fix already live. The app knew and had no way to say so; this is it saying
 * so, with the one button that resolves it.
 */

import { useEffect, useState } from 'react';
import { registerSW } from 'virtual:pwa-register';
import { Button } from './ui';
import s from './AppShell.module.scss';
import { PRODUCT } from '../lib/product';

export function UpdatePrompt() {
  const [waiting, setWaiting] = useState(false);
  const [reload, setReload] = useState<(() => void) | null>(null);

  useEffect(() => {
    /* Guarded because the dev server has no service worker, and because a
       browser with them disabled should get an app rather than a crash. */
    if (!('serviceWorker' in navigator)) return;

    const update = registerSW({
      onNeedRefresh() {
        setWaiting(true);
      },
    });
    setReload(() => update);
  }, []);

  if (!waiting) return null;

  return (
    <div className={s.updatePrompt} role="status">
      <i className="ti ti-refresh-dot" aria-hidden />
      <span>A newer version of {PRODUCT.name} is ready.</span>
      <Button
        primary
        icon="ti-reload"
        onClick={() => {
          /* Takes control and reloads every tab, which is the part that a manual
             refresh cannot do. */
          reload?.();
        }}
      >
        Reload
      </Button>
    </div>
  );
}
